import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) { }

  // getall
  public GetAll(params): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/post/getall`, this.httpOptions);
  }

  public Find(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/post/find/` + id, this.httpOptions);
  }

  // update
  // inserts
  // delete
  // find
}
